import { Component, OnInit, OnDestroy } from '@angular/core';
import { Router } from '@angular/router';

import { Result } from '../../@core/data/result';
import { RestService } from '../../@core/utils/rest.service';
import { NcalayerService } from '../../@core/utils/ncalayer/ncalayer.service';
import { AuthGuardService } from '../../@core/utils/auth-guard-service.service';

@Component({templateUrl: './login.component.html'})
export class LoginComponent implements OnInit, OnDestroy {  
  loading:boolean = false;
  submitted:boolean = false;    
  subscription: any;

  constructor(public rest:RestService, 
              public ncalayer: NcalayerService, 
              private router: Router,
              public auth:AuthGuardService) {}
  
              
  ngOnInit() {
    //sessionStorage.setItem('jurPerson',null);
    this.subscription = this.ncalayer.getXmlSidngeEmitter().subscribe(
      item => this.getJurPersonInfo(item));
  }

  private getJurPersonInfo(signedXml:string):void {
    if (signedXml != "") {
      this.rest.getJurPersonInfo(signedXml).subscribe((data: Result) => {                
        if (data.code == '0') {
          try
          {
            sessionStorage.setItem('errorMessage', '');
            sessionStorage.setItem('jurPerson', data.message);  
            this.router.navigate(['/app/jur/cabinet']);   
           // this.router.navigate(['/pages/jur']);  
            //this.router.navigate(['/cabinet']);                               
          }
          catch(e)
          {
            sessionStorage.setItem('errorMessage', e.message);
            sessionStorage.setItem('jurPerson', '');
            console.error('error - 1 - ' + e.message);                                
          }
        }        
        else {
          sessionStorage.setItem('errorMessage', data.message);
          sessionStorage.setItem('jurPerson', '');
          console.error('error - 2 - ' + data.message);                              
        }
        this.loading = false;                
      },
      error => {          
        sessionStorage.setItem('errorMessage', error);
        sessionStorage.setItem('jurPerson', '');
        this.router.navigate(['/cabinet']);  
        console.error('error - 3 - ' + error);   
        this.loading = false;                               
      });
    }
  }

  ngOnDestroy() {
    this.subscription.unsubscribe();
  }
  
  test() {
    this.submitted = true;        
    this.loading = true;
    
    let xmlData = `
      <data><bin>141040014901</bin></data>
    `;
    this.ncalayer.getActiveTokensCall(xmlData);
         
  }  
}
